import styled from 'styled-components/macro'

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme, themeColor = 'greyL2' }) =>
    theme.color[themeColor]};
`
